import { Typography, useTheme, Box, SxProps, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getStatusConsDetail } from '../helpers';

interface StatusBulletProps {
  status: string;
  tPath?: string;
  sx?: SxProps<Theme>;
}

const StatusBullet = ({ status, tPath, sx }: StatusBulletProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center" sx={{ ...sx }}>
      <Box
        component="span"
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          backgroundColor: getStatusConsDetail(status, theme),
          marginRight: 1,
          flexShrink: 0,
        }}
      />
      <Typography
        variant="body1"
        // fontWeight="bold"
        sx={{
          fontSize: theme.custom.tableFontSizePx,
        }}
      >
        {tPath ? t(tPath) : status}
      </Typography>
    </Box>
  );
};

export default StatusBullet;
